import React, { useState, useEffect, useContext } from 'react'
import { Tooltip } from '@mui/material'
import { BufferService, LoadingContext, M_InputTextField, M_DrawerTableTextField, M_StateActions, NavigateContext } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { MMap } from 'src/components/M_Components'
import './formsTable.css'

export default function CreatePriceZone() {
    const dispatch = useDispatch()
    const M_State = useSelector((state) => state.StateKeyValue)
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [dataPriceZone, setDataPriceZone] = useState(new Map())
    const [optionsPriceZone, setOptionsPriceZone] = useState([])
    const [priceZoneId, setPriceZoneId] = useState("")
    const [operation, setOperation] = useState("")
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const bufferServicePriceZone = new BufferService('PriceZone')
    const { t } = useTranslation()
    const [points, setPoints] = useState([])
    const sessionKeys = ['dataPriceZone', 'optionsPriceZone', 'priceZoneId', 'operation']

    useEffect(() => {
        if (isFirstLoop) {
            ctx.setIsLoad(true)
            getSessionStorageData(id);
            setIsFirstLoop(false)
        }
        // eslint-disable-next-line 
    }, [])

    // eslint-disable-next-line 
    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        const tempArray = []
        sessionKeys.forEach((key) => {
            tempArray.push(sessionStorageMachine(id, key, key))
        })
        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
        // eslint-disable-next-line
    }, [id, dataPriceZone, optionsPriceZone, priceZoneId, operation])

    const sessionStorageMachine = (id, key, value) => {
        let tempObj = {}
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
        } else {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (eval(value)) }
        }
        return tempObj
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempDP = M_StateData.filter(obj => obj.key === `dataPriceZone`)[0]?.value
            const tempOPZ = M_StateData.filter(obj => obj.key === `optionsPriceZone`)[0]?.value
            const tempPI = M_StateData.filter(obj => obj.key === `priceZoneId`)[0]?.value
            const tempOP = M_StateData.filter(obj => obj.key === `operation`)[0]?.value
            if (tempDP || tempOPZ || tempPI || tempOP) {
                setDataPriceZone(new Map(tempDP))
                setOptionsPriceZone(tempOPZ)
                setPriceZoneId(tempPI)
                setOperation(tempOP)
                ctx.setIsLoad(false)
                return
            }
        }
        getPriceZone()
    }

    const getPriceZone = () => {
        const getOperation = ctx.passValue.get('operation')
        const lines = ctx.passValue?.get('lines') || ""
        const getId = lines.Id
        ctx.passValue.delete('operation')
        ctx.passValue.delete('lines')
        ctx.setPassValue(new Map(ctx.passValue))
        setOperation(getOperation)
        setPriceZoneId(getId)

        ctx.setIsLoad(true)
        bufferServicePriceZone.options().then((responseOptions) => {
            if (responseOptions.name === 'AxiosError') {
                ctx.toastMessages('error', responseOptions.response.data.Errors[0], '')
                return
            }
            const filteredOptions = responseOptions.filter((option) => !option.IsHiddenList)
            setOptionsPriceZone(filteredOptions)

            if (getOperation === 'edit') {
                bufferServicePriceZone.getId(getId).then((response) => {
                    if (response.name === 'AxiosError') {
                        ctx.toastMessages('error', response.response.data.Errors[0], '')
                        ctx2.closeTab(id)
                        return
                    }
                    const valueDataPriceZone = response
                    responseOptions.forEach(obj => {
                        dataPriceZone.set(obj.Name, valueDataPriceZone[obj.Name])
                    })
                    setPoints([
                        {
                            latitude: valueDataPriceZone.Latitude,
                            longitude: valueDataPriceZone.Longitude,
                        }
                    ])
                    setDataPriceZone(new Map(dataPriceZone))
                    ctx.setIsLoad(false)
                })
            }
        })
        ctx.setIsLoad(false)
    }

    const priceZoneStructure = (event, index) => {
        if (event.type === "date") {
            const dateValue = new Date(event).toISOString().split("T")[0]
            dataPriceZone.set(index, dateValue)
        } else {
            dataPriceZone.set(index, event)
        }
        setDataPriceZone(new Map(dataPriceZone))
    }

    const submitPriceZone = () => {
        dataPriceZone.set('Latitude', points[0]?.latitude)
        dataPriceZone.set('Longitude', points[0]?.longitude)
        const requiredFieldsPriceZone = optionsPriceZone.filter((elem) => elem.IsRequired)
        for (const field of requiredFieldsPriceZone) {
            if (!dataPriceZone.has(field.Name) || !dataPriceZone.get(field.Name)) {
                ctx.toastMessages('error', field.NormalizedName, t("RequiredField"))
                return
            }
        }
        ctx.setIsLoad(true)

        if (operation === 'edit') {
            bufferServicePriceZone.update(priceZoneId, Object.fromEntries(dataPriceZone)).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages("error", '', t("ErrorUpdate"))
                    ctx.setIsLoad(false)
                    return
                }
                ctx.toastMessages("success", '', t("SuccessUpdate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        } else {
            bufferServicePriceZone.post(Object.fromEntries(dataPriceZone)).then((response) => {
                if (response.name === 'AxiosError') {
                    if (response.response.data.Errors[0] === 'DuplicateZoneCode') {
                        ctx.toastMessages("error", '', t(response.response.data.Errors[0]))
                        ctx.setIsLoad(false)
                        return
                    } else {
                        ctx.toastMessages("error", '', t("ErrorCreate"))
                        ctx.setIsLoad(false)
                        return
                    }

                }
                ctx.toastMessages("success", '', t("SuccessCreate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        }
    }

    return (
        <div className='backgroundForms'>
            <div className="display">
                <div className="menuIcon">
                    <Tooltip title={t("Close")} className='iconsHeaderTable'>
                        <div className='iconsHeaderTable' onClick={() => ctx2.closeTab(id)}>
                            <i className="pi pi-arrow-left iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Close")}</b></span>
                        </div>
                    </Tooltip>
                    <Tooltip title={t("Save")}>
                        <div className='iconsHeaderTable' onClick={submitPriceZone}>
                            <i className="pi pi-save iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Save")}</b></span>
                        </div>
                    </Tooltip>
                </div>
            </div>
            <div className='dividerMenu'></div>
            <div className='divAlignFormPriceZone'>
                <div className='divFormPriceZone'>
                    {optionsPriceZone.map((elem) => (
                        <div key={elem.Name}>
                            {elem.Type === 'string' ? (
                                elem.IsForeignKey ? (
                                    <M_DrawerTableTextField
                                        tableLabel={elem.NormalizedName}
                                        label={elem.NormalizedName}
                                        required={elem.Required}
                                        entity={elem.ForeignTableName}
                                        value={dataPriceZone.get(elem.ForeignTableToPassId) ?
                                            {
                                                [elem.ForeignTableToPassId]: dataPriceZone.get(elem.ForeignTableToPassId),
                                                [elem.ForeignKeyName]: dataPriceZone.get(elem.Name)
                                            } : null}
                                        filterField={elem.ForeignKeyName}
                                        labelFields={[elem.ForeignKeyName]}
                                        onSubmitValue={obj => {
                                            if (obj) {
                                                dataPriceZone.set(elem.Name, obj[elem.ForeignKeyName])
                                                dataPriceZone.set(elem.ForeignTableToPassId, obj[elem.ForeignTableToPassId])
                                            } else {
                                                dataPriceZone.set(elem.Name, null)
                                                dataPriceZone.set(elem.ForeignTableToPassId, null)
                                            }
                                            setDataPriceZone(new Map(dataPriceZone))
                                        }}
                                        disabled={elem.disable}
                                        valueField={elem.ForeignTableToPassId}
                                    />
                                ) : (
                                    < M_InputTextField
                                        type={"text"}
                                        label={elem.NormalizedName}
                                        secondColor={"var(--color-red-dark)"}
                                        required={elem.IsRequired}
                                        onChange={(e) => priceZoneStructure(e.target.value, elem.Name)}
                                        value={dataPriceZone.get(elem.Name) || ""}
                                    />
                                )
                            ) : elem.Type === 'int32' ? (
                                < M_InputTextField
                                    type={"number"}
                                    label={elem.NormalizedName}
                                    secondColor={"var(--color-red-dark)"}
                                    required={elem.IsRequired}
                                    onChange={(e) => priceZoneStructure(e.target.value, elem.Name)}
                                    value={dataPriceZone.get(elem.Name) || ""}
                                />
                            ) : elem.Type === 'datetime' ? (
                                <M_InputTextField
                                    type={"date"}
                                    label={elem.NormalizedName}
                                    secondColor={"var(--color-red-dark)"}
                                    required={elem.IsRequired}
                                    onChange={(e) => priceZoneStructure(e.target.value, elem.Name)}
                                    value={dataPriceZone.get(elem.Name) || ""}
                                />
                            ) : ""}
                        </div>
                    ))}
                </div>

                <div className='mapPriceZone'>
                    <h2>{t("DefineReferencePoint")}</h2>
                    <h5>{t("RequiredReferencePoint")}</h5>
                    <br />
                    <MMap
                        height={"450px"}
                        navigationControl
                        controlScale
                        fullscreen
                        findMyLoc
                        satelliteView
                        pointGet
                        numberGetPoints={1}
                        points={points}
                        setPoints={setPoints}
                    />
                </div>

            </div>
        </div>
    )
}